module.exports = __webpack_public_path__ + "img/calendar-19.d7334d66.svg";